document.addEventListener('DOMContentLoaded', initNkCollageNkten);
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initNkCollageNkten);
}

function initNkCollageNkten(event) {
  const root = event && event.target && event.target.querySelector
    ? event.target.querySelector('[data-nk-collage-nkten]')
    : document.querySelector('[data-nk-collage-nkten]');

  const sections = root ? [root] : document.querySelectorAll('[data-nk-collage-nkten]');

  sections.forEach((section) => {
    if (!section) return;

    const grid = section.querySelector('[data-nk-collage-grid]');
    const template = section.querySelector('[data-nk-collage-images]');
    if (!grid || !template) return;

    const sourceImages = Array.from(template.content.querySelectorAll('img')).map((img) => ({
      src: img.getAttribute('src'),
      srcset: img.getAttribute('data-srcset'),
      alt: img.getAttribute('alt') || '',
    }));

    if (sourceImages.length === 0) return;

    // Re-render on theme editor updates instead of skipping.
    grid.innerHTML = '';

    const tileCount = parseInt(section.dataset.tileCount, 10) || 220;
    const uniformTiles = section.dataset.uniformTiles === 'true';
    const sizeVariants = uniformTiles
      ? ['']
      : ['', '', '', 'nk-collage-nkten__tile--wide', 'nk-collage-nkten__tile--tall', 'nk-collage-nkten__tile--large'];
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function randomOf(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    const fragment = document.createDocumentFragment();
    const tiles = [];

    for (let i = 0; i < tileCount; i += 1) {
      const source = randomOf(sourceImages);
      const variant = randomOf(sizeVariants);

      const tile = document.createElement('div');
      tile.className = 'nk-collage-nkten__tile' + (variant ? ' ' + variant : '');

      const img = document.createElement('img');
      img.src = source.src;
      if (source.srcset) img.srcset = source.srcset;
      img.sizes = '150px';
      img.loading = 'lazy';
      img.alt = source.alt;
      img.style.objectPosition = `${Math.random() * 100}% ${Math.random() * 100}%`;
      img.style.transform = `scale(1.15) rotate(${(Math.random() * 10 - 5).toFixed(2)}deg)`;

      tile.appendChild(img);
      fragment.appendChild(tile);
      tiles.push(tile);
    }

    grid.appendChild(fragment);

    if (prefersReducedMotion) {
      tiles.forEach((tile) => tile.classList.add('is-visible'));
      return;
    }

    tiles.forEach((tile, index) => {
      window.setTimeout(() => {
        tile.classList.add('is-visible');
      }, index * 12);
    });
  });
}
